import { render } from "./FooterReport.vue?vue&type=template&id=9fb3b6da&scoped=true&ts=true"
import script from "./FooterReport.vue?vue&type=script&lang=ts"
export * from "./FooterReport.vue?vue&type=script&lang=ts"

import "./FooterReport.vue?vue&type=style&index=0&id=9fb3b6da&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb3b6da"]])

export default __exports__